<template>
  <div class="panel">
    <div class="panel-heading">
      <h3 class="panel-title text-center">
        Посещения по времени суток
        <i
          class="icon md-help-outline cursor-pointer"
          aria-hidden="true"
          data-toggle="popover"
          data-html="true"
          data-trigger="click | hover"
          data-content="
              Данные за последний месяц<br />
              <br />
              <b>Утро</b> - с 6 до 9 часов.<br />
              <b>День</b> - с 9 до 18 часов.<br />
              <b>Вечер</b> - с 18 до 22 часов.<br />
              <b>Ночь</b> - с 22 до 6 часов."
        ></i>
      </h3>
    </div>
    <div class="panel-body">
      <div class="report-content" style="width: 100%">
        <span v-if="loading" class="error loading status_padding">
          <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>Загрузка
          данных...
        </span>

        <span v-else-if="error" class="error status_padding">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Ошибка
          загрузки данных
        </span>

        <span v-else-if="isStatsEmpty">
          <p class="error no-data-message">Нет данных для статистики</p>
        </span>
        <GChart
          v-else
          type="PieChart"
          :data="chartData"
          :options="chartOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts/legacy";

export default {
  name: "HoursStatsUsersDiagram",
  data() {
    return {
      loading: true,
      error: false,
      times: [],
      chartOptions: {
        legend: { position: "bottom" },
        width: "100%",
        height: 400,
        colors: ["#39f", "#36c", "#3cf", "#336"],
      },
    };
  },
  computed: {
    chartData() {
      return [["Время суток", "Количество людей"], ...this.times];
    },
    isDataEmpty() {
      return this.times.length === 0;
    },
    isPointsEmpty() {
      return this.times.every((point) => {
        return point[1] === 0;
      });
    },
    isStatsEmpty() {
      return this.isDataEmpty || this.isPointsEmpty;
    },
  },
  components: {
    GChart,
  },
  methods: {
    get_data() {
      axios
        .get("/widgets/HoursStatsUsers")
        .then((response) => {
          this.times = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
        });
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>

<style scoped>
.md-help-outline {
  color: #ff6611;
}
.error,
.loading {
  display: inline-block;
}
.error i,
.loading i {
  margin-right: 5px;
}

.error {
  font-weight: bold;
}
</style>
